import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your language JSON files
import en from './locales/en.json';
import fr from './locales/fr.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    fr: {
      translation: fr,
    },
  },
  lng: 'fr', // Default language
  fallbackLng: 'fr', // Fallback language
  interpolation: {
    escapeValue: false, // React already escapes strings
  },
});

export default i18n;
